import { media, scrollbar } from "src/styles/mixins";
import styled from "styled-components";

export const GameSummaryTaskListHeader = styled.div`
  display: flex;
  margin-top: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  margin-right: 30px;
`;

export const TaskListHeaderCell = styled.div`
  flex: 1;
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.xxxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-weight: ${({ theme }) => theme.fonts.weights.thin};
  padding: 0 10px;
  white-space: nowrap;

  &:first-child {
    text-align: left;
    flex: 2;
  }
`;

export const GameSummaryTaskListWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 20px;
  padding-right: 27px;

  ${scrollbar}
`;

export const GameSummaryTaskListItem = styled.div`
  display: flex;

  ${media.up("LAPTOP")`
    width: 60vw;
  `}

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors.primary};
  }
`;

export const TaskListItemCell = styled.div`
  flex: 1;
  text-align: center;
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.s};
  padding: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;

  &:first-child {
    text-align: left;
    flex: 2;
  }
`;

export const GameSummaryEmpty = styled.div`
  text-align: center;
  padding: 40px 0;
  color: ${({ theme }) => theme.colors.primary70};
`;
